export default "__VITE_ASSET__DaMcKdD7__"